<router-outlet></router-outlet>
<div id="single-spa-application:webchat-ui"></div>
